import { __assign, __rest, __spreadArray } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import { Wrapper, Label, Inner, SearchBar, Menu, SearchBox, Item, Tag, Message, Hint } from './select.style';
import { Chip } from '../chip/chip';
export var Select = function (_a) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? 'outline' : _c, _d = _a.status, status = _d === void 0 ? 'normal' : _d, disabled = _a.disabled, hint = _a.hint, message = _a.message, label = _a.label, id = _a.id, _e = _a.size, size = _e === void 0 ? 'md' : _e, options = _a.options, _f = _a.defaultValue, defaultValue = _f === void 0 ? [{ value: '', label: '' }] : _f, multi = _a.multi, searchable = _a.searchable, onChange = _a.onChange, _g = _a.className, className = _g === void 0 ? '' : _g, padding = _a.padding, placeholder = _a.placeholder, value = _a.value, props = __rest(_a, ["variant", "status", "disabled", "hint", "message", "label", "id", "size", "options", "defaultValue", "multi", "searchable", "onChange", "className", "padding", "placeholder", "value"]);
    var _h = useState(false), showMenu = _h[0], setShowMenu = _h[1];
    var _j = useState(value || defaultValue), selectedValue = _j[0], setSelectedValue = _j[1];
    var _k = useState(''), searchValue = _k[0], setSearchValue = _k[1];
    var searchRef = useRef(null);
    var inputRef = useRef(null);
    var refIconRight = useRef(null);
    useEffect(function () {
        setSearchValue('');
        if (showMenu && searchRef.current) {
            searchRef.current.focus();
        }
    }, [showMenu]);
    useEffect(function () {
        var handler = function (e) {
            if (inputRef.current && !inputRef.current.contains(e.target)) {
                setShowMenu(false);
            }
        };
        window.addEventListener('click', handler);
        return function () {
            window.removeEventListener('click', handler);
        };
    });
    useEffect(function () {
        if (value) {
            setSelectedValue(value);
        }
    }, [value]);
    var handleInputClick = function (e) {
        e.preventDefault();
        setShowMenu(!showMenu);
        var iconRight = refIconRight.current;
        iconRight.classList.toggle('open');
    };
    var getDisplay = function () {
        var _a;
        if (multi) {
            return (React.createElement(Tag, null, selectedValue.map(function (option) { return (React.createElement(Chip, { key: option === null || option === void 0 ? void 0 : option.value, onClose: function (e) { return onTagRemove(e, option); }, closable: true }, option === null || option === void 0 ? void 0 : option.label)); })));
        }
        return ((_a = selectedValue[0]) === null || _a === void 0 ? void 0 : _a.label) || React.createElement("span", { className: 'placeholder' }, placeholder);
    };
    var removeOption = function (option) {
        return selectedValue.filter(function (item) { return item.value !== option.value; });
    };
    var onTagRemove = function (e, option) {
        e.stopPropagation();
        var newValue = removeOption(option);
        setSelectedValue(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    var onItemClick = function (option) {
        var newValue = [];
        if (multi) {
            if (selectedValue.findIndex(function (item) { return item.value === option.value; }) >= 0) {
                newValue = removeOption(option);
            }
            else {
                newValue = __spreadArray(__spreadArray([], selectedValue, true), [option], false);
            }
        }
        else {
            newValue = [option];
        }
        setSelectedValue(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    var isSelected = function (option) {
        var _a;
        if (multi) {
            return selectedValue.filter(function (item) { return item.value === option.value; }).length > 0;
        }
        if (!selectedValue) {
            return false;
        }
        return ((_a = selectedValue[0]) === null || _a === void 0 ? void 0 : _a.value) === option.value;
    };
    var onSearch = function (e) {
        setSearchValue(e.target.value);
    };
    var getOptions = function () {
        if (!searchValue) {
            return options;
        }
        return options && (options === null || options === void 0 ? void 0 : options.filter(function (option) { return option.label.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0; }));
    };
    return (React.createElement(Wrapper, __assign({ className: "legion-select ".concat(className), id: id, padding: padding }, props),
        label && React.createElement(Label, { htmlFor: id }, label),
        React.createElement(Inner, { status: status, variant: variant, disabled: disabled },
            React.createElement(SearchBar, { size: size, disabled: disabled, ref: inputRef, onClick: handleInputClick },
                getDisplay(),
                " ",
                React.createElement("span", { ref: refIconRight, className: 'toggle-arrow' })),
            showMenu && !disabled && (React.createElement(Menu, null,
                searchable && (React.createElement(SearchBox, null,
                    React.createElement("input", { type: 'search', onChange: onSearch, value: searchValue, ref: searchRef }))), (_b = getOptions()) === null || _b === void 0 ? void 0 :
                _b.map(function (option) { return (React.createElement(Item, { onClick: function () { return onItemClick(option); }, key: option.value, isSelected: isSelected(option) }, option.label)); })))),
        message && React.createElement(Message, { status: status }, message),
        hint && React.createElement(Hint, null, hint)));
};
